import React from "react";
import "../styles/register.css";

export const Register = () => {
  return (
    <>
      <div className="main-container">
        <h1 className="main-title valign-text-middle roboto-medium-black-48px">
          Sign up for Social Media Digest
        </h1>
        <div className="signup-container">
          <div className="form-container">
            <form action="/register" method="POST" className="sign-up-form">
              <div className="first-name-enter">
                <h2 className="second-title valign-text-middle roboto-bold-black-24px">
                  First Name
                </h2>
                <input
                  className="input"
                  type="text"
                  name="firstName"
                  id="first-name"
                  required
                />
              </div>
              <div className="first-name-enter">
                <h2 className="second-title valign-text-middle roboto-bold-black-24px">
                  Second Name
                </h2>
                <input
                  className="input"
                  type="text"
                  name="secondName"
                  id="second-name"
                  required
                />
              </div>
              <div className="first-name-enter">
                <h2 className="second-title valign-text-middle roboto-bold-black-24px">
                  Date of Birth
                </h2>
                <input
                  className="input"
                  type="date"
                  name="dob"
                  id="dob"
                  required
                />
              </div>
              <div className="first-name-enter">
                <h2 className="second-title valign-text-middle roboto-bold-black-24px">
                  Email
                </h2>
                <input
                  className="input"
                  type="email"
                  name="email"
                  id="email"
                  required
                />
              </div>
              <div className="first-name-enter">
                <h2 className="second-title valign-text-middle roboto-bold-black-24px">
                  Mobile Number
                </h2>
                <input
                  className="input"
                  type="tel"
                  name="mobile"
                  id="mobile"
                  required
                />
              </div>
              <div className="first-name-enter">
                <h2 className="second-title valign-text-middle roboto-bold-black-24px">
                  Password
                </h2>
                <input
                  className="input"
                  type="password"
                  name="password"
                  id="password"
                  required
                />
              </div>
              <div className="submit-container">
                <input
                  type="submit"
                  className="button-primary btn white s18px"
                  value="Register"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
